import PublicLayout from '../layout/publicLayout'
import PrivacyPolicyAndTermsOfService from '../pages/common/PrivacyPolicyAndTermsOfService'
// ==============================|| PUBLIC PAGES ROUTING WITH NAVIGATION HEADER ||============================== //
import ComingSoonPage from '../pages/common/comingSoon'
import ContactUs from '../pages/common/contactUs'
import FeaturesPage from '../pages/common/featuresPage'
import HomePage from '../pages/common/landingPage'
import FAQSection from '../pages/common/landingPage/faq'
const PublicRoutes = {
  path: '/',
  element: <PublicLayout />,
  children: [
    {
      path: '/',
      element: <HomePage />,
    },
    {
      path: 'home',
      element: <HomePage />,
    },
    {
      path: 'contact-us',
      element: <ContactUs />,
    },
    {
      path: 'faq',
      element: <FAQSection />,
    },
    {
      path: 'privacy-policy',
      element: <PrivacyPolicyAndTermsOfService />,
    },
    {
      path: 'termsofservice',
      element: <PrivacyPolicyAndTermsOfService />,
    },
    {
      path: 'coming-soon',
      element: <ComingSoonPage />,
    },
    {
      path: 'features',
      element: <FeaturesPage />,
    },
  ],
}

export default PublicRoutes
